import { FC } from "react";
import styles from "./Avatar.module.css";
import { LuUserRound } from "react-icons/lu";

interface AvatarProps {
  src?: string;
  alt: string;
  size?: "small" | "medium" | "large";
}

export const Avatar: FC<AvatarProps> = ({ src, alt, size = "medium" }) => {
  // Определяем размеры иконки на основе класса размера
  const getIconSize = () => {
    switch (size) {
      case "small":
        return 24;
      case "large":
        return 56;
      case "medium":
      default:
        return 40;
    }
  };

  if (src) {
    return (
      <img src={src} alt={alt} className={`${styles.avatar} ${styles[size]}`} />
    );
  }

  return (
    <div
      className={`${styles.avatar} ${styles[size]}`}
      aria-label={alt}
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <LuUserRound size={getIconSize()} />
    </div>
  );
};
